<template>
    <div class="flex items-center relative">

          <div v-show="isHidden">
            <p>
              {{content}}<a v-on:click="isHidden = !isHidden" class="text-xxs align-middle cursor-pointer"><i aria-hidden="true" class="material-icons align-middle text-sm mx-1">edit</i>Change</a>
            </p>
          </div>
          <div v-if="!isHidden" class="flex w-full items-center">
            <div class="flex flex-row items-center pl-2 pr-1 w-9/12 bg-white border border-gray-300">
              {{orgname}}-
              <input class="w-full bg-transparent border-0 pl-1" id="groupName" type="text"
                     @keydown.enter="putItem"
                     v-model="value"
                     v-mask="vmask"
                     autofocus
                     placeholder="EnterCodeHere" 
              />
            </div>
            <div class="w-3/12 pl-2" v-show="isSure">
              <a v-on:click="isSure = !isSure" class="commitbutton p-0 inline-block cursor-pointer">Save <i aria-hidden="true" class="material-icons align-middle text-4xl">check</i></a>
            </div>
          </div>
          <div v-if="!isSure" class="bg-red-600 text-white w-full p-3 absolute top-0 text-sm z-50" v-click-outside="onClickOutside">
              {{confirmtext}} <br>
              <button v-on:click="putItem" type="submit" class="btn text-sm bg-white text-red-700 commitbutton mt-1 rounded px-3 py-1"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i>Yes, Do It</button>
          </div>
      </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import VueMask from 'v-mask'
Vue.use(VueMask);
import axios from 'axios'


  export default {

        props: {
            content: '',
            route:'',
            routeparam:'',
            orgname:'',
            confirmtext: {
              default: 'Are You Sure?',
            },
            buttonname: {
              default: 'Change',
            },
            buttonicon: {
              default: 'edit',
            },
            buttonsize: {
              default: 'text-xs',
            },
            inputmask: {
              default: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
            },
        },

        data() {
          return {
            isHidden: true,
            isSure: true,
            success: false,
            loaded: true,
            value: '',
            vmask: this.inputmask,
          }
        },
        
        directives: {
          clickOutside: vClickOutside.directive
        },
        
        methods: {
          onClickOutside (event) {
              this.isSure = !this.isSure
          },
          
          formfocus() {
              document.getElementById("groupName").focus();
          },
          mounted(){
            this.formfocus()
          },

          putItem: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.put(this.route,
                { [this.routeparam]: this.value }
              )
              .then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },
      }
</script>
